import Env from '../base/env';
import { module as BaseModule } from 'modujs';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class extends BaseModule  {
  constructor(m) {
    super(m);
  }

  init() {
    this.PLAYED = false
    setTimeout(() => {
      this.el.pause()
    }, 100);
    // this.el.play().then(()=>{
    //   setTimeout(() => {
    //     this.el.pause()
    //   }, 100);

    // })
    this.el.addEventListener('suspend', () => {
      // suspend invoked
      // show play button
      // iphone is in low power mode
      // alert('low power')
      // console.log('uss');
    });
    this.el.addEventListener('canplay', () => {
      // suspend invoked
      // show play button
      // iphone is in low power mode
      // if(this.PLAYED == false) {
        // console.log('baller');
        gsap.fromTo(
          this.el,
          {
            autoAlpha:0
          },
          {
            autoAlpha:1,
            ease:'cubic.inOut',
            duration:1,
            onStart:()=> this.el.style.zIndex = '2'
          }
        )
        this.PLAYED = true
      // }

    })

    const offsetStart = (Env.mobileCSS)?'top bottom-=200px':'top center';

    this.listener = ScrollTrigger.create({
      trigger:this.el,
      start:offsetStart,
      markers:false,
      once:true,
      onEnter:()=> {
        this.el.play()
      }
    })
  }



  destroy() {
    // window.removeEventListener('resize', this.bindResize);
  }


}
